export default "__VITE_ASSET__t3CMLlWt__"